<!-- KONE: Override upstream Logo.vue with KONE branding -->
<template>
  <img :src="logoUrl" alt="KONE" v-bind="$attrs" />
</template>

<script setup lang="ts">
const logoUrl = new URL(
  "../../../../../assets/kone/KONE_Logo.svg",
  import.meta.url
).href
</script>
